module.exports = __webpack_public_path__ + "media/4x3/nf-99af5a94.svg";